import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { message } from "../../Reducers/loading/actions";
import { FetchAIInstructies, SaveAIInstructies } from "./Reducers/items/actions";

const AIInstructiesItems = ({ dispatch }) => {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [settings, setSettings] = useState({
    algemeen: "Schrijf inspirerende en informatieve content voor VVV items die gasten helpen om interessante locaties en evenementen te ontdekken in de regio.",
    korte_beschrijving: "Schrijf een korte, pakkende beschrijving van maximaal 2-3 zinnen die de essentie van het item samenvat. Focus op de unieke eigenschappen en waarom gasten dit niet mogen missen. Gebruik actieve taal en wees concreet. Gebruik <strong> tags voor belangrijke woorden.",
    lange_beschrijving: "Schrijf een uitgebreide beschrijving van 3-5 alinea's die gasten volledig informeert over het item. Begin met een aantrekkelijke opening, geef praktische details, beschrijf de sfeer en ervaring, en sluit af met waarom dit item de moeite waard is. Gebruik een enthousiasmerende maar authentieke toon. Structureer met kopjes (<h3> voor hoofdonderwerpen) en gebruik opsommingen (<ul><li>) voor praktische details. Markeer belangrijke informatie met <strong> tags."
  });

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    setLoading(true);
    try {
      const data = await dispatch(FetchAIInstructies());
      if (data && Object.keys(data).length > 0) {
        setSettings({ ...settings, ...data });
      }
    } catch (error) {
      console.error("Fout bij ophalen instellingen:", error);
    }
    setLoading(false);
  };

  const saveSettings = async () => {
    setSaving(true);
    try {
      await dispatch(SaveAIInstructies(settings));
      dispatch(message(3000, "success", "AI instructies succesvol opgeslagen!"));
    } catch (error) {
      dispatch(message(3000, "error", "Fout bij opslaan instellingen"));
      console.error("Save error:", error);
    }
    setSaving(false);
  };

  const handleInputChange = (field, value) => {
    setSettings({
      ...settings,
      [field]: value,
    });
  };

  const resetToDefaults = () => {
    setSettings({
      algemeen: "Schrijf inspirerende en informatieve content voor VVV items die gasten helpen om interessante locaties en evenementen te ontdekken in de regio.",
      korte_beschrijving: "Schrijf een korte, pakkende beschrijving van maximaal 2-3 zinnen die de essentie van het item samenvat. Focus op de unieke eigenschappen en waarom gasten dit niet mogen missen. Gebruik actieve taal en wees concreet. Gebruik <strong> tags voor belangrijke woorden.",
      lange_beschrijving: "Schrijf een uitgebreide beschrijving van 3-5 alinea's die gasten volledig informeert over het item. Begin met een aantrekkelijke opening, geef praktische details, beschrijf de sfeer en ervaring, en sluit af met waarom dit item de moeite waard is. Gebruik een enthousiasmerende maar authentieke toon. Structureer met kopjes (<h3> voor hoofdonderwerpen) en gebruik opsommingen (<ul><li>) voor praktische details. Markeer belangrijke informatie met <strong> tags."
    });
  };

  if (loading) {
    return (
      <div className="box box-default">
        <div className="box-body">
          <div className="text-center">
            <i className="fa fa-spinner fa-spin fa-3x"></i>
            <p>Laden...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="box box-default">
      <div className="box-header with-border">
        <h3 className="box-title">
          <i className="fa fa-robot"></i> AI Instructies voor VVV Items
        </h3>
        <div className="box-tools pull-right">
          <button
            className="btn btn-default btn-sm"
            onClick={resetToDefaults}
            disabled={saving}
          >
            <i className="fa fa-undo"></i> Reset
          </button>
          &nbsp;
          <button
            className="btn btn-primary btn-sm"
            onClick={saveSettings}
            disabled={saving}
          >
            {saving ? (
              <>
                <i className="fa fa-spinner fa-spin"></i> Opslaan...
              </>
            ) : (
              <>
                <i className="fa fa-save"></i> Opslaan
              </>
            )}
          </button>
        </div>
      </div>

      <div className="box-body">
        <div className="alert alert-info">
          <h4><i className="icon fa fa-info"></i> Informatie</h4>
          <p>
            Definieer de instructies voor AI-gegenereerde teksten voor korte en lange beschrijvingen van VVV items.
            Deze instructies worden gebruikt wanneer u OpenAI vraagt om beschrijvingen te herschrijven.
          </p>
          <p>
            <strong>HTML Opmaak:</strong> De AI genereert automatisch HTML opmaak zoals kopjes, alinea's, opsommingen en vetgedrukte tekst.
            U kunt in uw instructies aangeven welke HTML elementen u wilt gebruiken.
          </p>
          <p>
            <strong>Status AI Instellingen:</strong> {settings.algemeen && settings.korte_beschrijving && settings.lange_beschrijving ?
              <span className="label label-success"><i className="fa fa-check"></i> Ingesteld</span> :
              <span className="label label-warning"><i className="fa fa-exclamation-triangle"></i> Niet volledig ingesteld</span>
            }
          </p>
        </div>

        {/* Algemene Instructie */}
        <div className="box box-primary">
          <div className="box-header with-border">
            <h3 className="box-title">
              <i className="fa fa-globe"></i> Algemene Instructie
            </h3>
          </div>
          <div className="box-body">
            <div className="form-group">
              <label>Algemene Prompt</label>
              <textarea
                className="form-control"
                rows="4"
                value={settings.algemeen}
                onChange={(e) => handleInputChange("algemeen", e.target.value)}
                placeholder="Algemene instructie die voor alle AI-generaties wordt gebruikt..."
              />
              <p className="help-block">
                Deze instructie wordt als basis gebruikt voor alle AI-gegenereerde teksten voor VVV items.
                Definieer hier de algemene toon, doelgroep en doel van de content.
              </p>
            </div>
          </div>
        </div>

        {/* Specifieke Instructies */}
        <div className="row">
          {/* Korte Beschrijving */}
          <div className="col-md-6">
            <div className="box box-success">
              <div className="box-header with-border">
                <h3 className="box-title">
                  <i className="fa fa-align-left"></i> Korte Beschrijving
                </h3>
              </div>
              <div className="box-body">
                <div className="form-group">
                  <label>Instructie voor Korte Beschrijving</label>
                  <textarea
                    className="form-control"
                    rows="8"
                    value={settings.korte_beschrijving}
                    onChange={(e) => handleInputChange("korte_beschrijving", e.target.value)}
                    placeholder="Instructie voor het herschrijven van de korte beschrijving..."
                  />
                  <p className="help-block">
                    Deze instructie wordt gebruikt wanneer u de korte beschrijving van een VVV item laat herschrijven door AI.
                    Geef duidelijk aan wat de lengte, toon en focus moet zijn. U kunt ook HTML tags vermelden die u wilt gebruiken (bijv. &lt;strong&gt; voor belangrijke woorden).
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Lange Beschrijving */}
          <div className="col-md-6">
            <div className="box box-success">
              <div className="box-header with-border">
                <h3 className="box-title">
                  <i className="fa fa-align-justify"></i> Lange Beschrijving
                </h3>
              </div>
              <div className="box-body">
                <div className="form-group">
                  <label>Instructie voor Lange Beschrijving</label>
                  <textarea
                    className="form-control"
                    rows="8"
                    value={settings.lange_beschrijving}
                    onChange={(e) => handleInputChange("lange_beschrijving", e.target.value)}
                    placeholder="Instructie voor het herschrijven van de lange beschrijving..."
                  />
                  <p className="help-block">
                    Deze instructie wordt gebruikt wanneer u de lange beschrijving van een VVV item laat herschrijven door AI.
                    Geef duidelijk aan wat de structuur, diepgang en toon moet zijn. U kunt HTML opmaak specificeren zoals &lt;h3&gt; voor kopjes, &lt;ul&gt;&lt;li&gt; voor opsommingen, en &lt;strong&gt; voor nadruk.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Preview Box */}
        <div className="box box-warning">
          <div className="box-header with-border">
            <h3 className="box-title">
              <i className="fa fa-eye"></i> Preview: Hoe Worden Deze Instructies Gebruikt?
            </h3>
          </div>
          <div className="box-body">
            <p><strong>Voorbeeld:</strong> Wanneer u een korte beschrijving laat herschrijven, wordt de volgende prompt naar OpenAI gestuurd:</p>

            <div className="well" style={{ backgroundColor: '#f4f4f4', padding: '15px', marginTop: '10px' }}>
              <p><strong>Algemene context:</strong></p>
              <p style={{ marginLeft: '15px' }}>{settings.algemeen}</p>

              <p><strong>Specifieke instructie voor korte beschrijving:</strong></p>
              <p style={{ marginLeft: '15px' }}>{settings.korte_beschrijving}</p>

              <p><strong>Huidige tekst:</strong></p>
              <p style={{ marginLeft: '15px', fontStyle: 'italic' }}>[De bestaande korte beschrijving van het VVV item]</p>

              <p><strong>Opdracht:</strong></p>
              <p style={{ marginLeft: '15px' }}>Herschrijf de bovenstaande tekst volgens de gegeven instructies.</p>
            </div>

            <div className="alert alert-warning" style={{ marginTop: '15px' }}>
              <h4><i className="icon fa fa-lightbulb-o"></i> Tips voor HTML Opmaak</h4>
              <p>
                <strong>Beschikbare HTML tags die u kunt gebruiken:</strong>
              </p>
              <ul>
                <li><code>&lt;h2&gt;, &lt;h3&gt;, &lt;h4&gt;</code> - Kopjes en subkopjes</li>
                <li><code>&lt;p&gt;</code> - Alinea's (standaard)</li>
                <li><code>&lt;strong&gt;</code> - Belangrijke tekst (vetgedrukt)</li>
                <li><code>&lt;em&gt;</code> - Nadruk (cursief)</li>
                <li><code>&lt;ul&gt; en &lt;li&gt;</code> - Ongeordende lijsten</li>
                <li><code>&lt;ol&gt; en &lt;li&gt;</code> - Geordende lijsten</li>
              </ul>
              <p>
                Zorg ervoor dat uw instructies duidelijk en specifiek zijn. Geef aan welke HTML opmaak u wilt gebruiken,
                wat de gewenste toon is, en wat de doellengte is. Hoe duidelijker uw instructies, hoe beter de AI-gegenereerde teksten zullen zijn.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(AIInstructiesItems);
